
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { supplementPost } from '@/service/vioReport'
import Upload from '@components/common/upload/upload'
import { IMG_SERVER } from '@/consts/const'
export default {
components: { Upload, Cell, CellBox, XButton },
data () {
return {
uploadHeader: {},
imgServer: IMG_SERVER,
minSize: 3,
file: [],
files: [],
id: '',
file1: '',
file2: '',
file3: '',
bpbg1: require('../../assets/picBg1.png'),
bpbg2: require('../../assets/picBg1.png'),
bpbg3: require('../../assets/picBg1.png')
}
},
computed: {
imgNumerText: function () {
return this.minSize > 2 ? '必须上传3张照片' : '必须上传2张及以上照片'
},
videoName: function () {
return this.file.length === 1 ? this.file[0].name : ''
},
isPassed: function () {
console.log(this.files1, this.files2, this.files3, this.files.length)
if (this.files1 || this.files2 || this.files3 || this.files.length > 0) {
} else {
return {
msg: '请按规定上传违法证据!',
status: false
}
}







return {
msg: '',
status: true
}
}
},
created () {
this.id = this.$route.query && this.$route.query.id
this.uploadHeader = { 'X-Token': localStorage.getItem('token') }
},
methods: {
deleteImg (index) {
this.files.splice(index, 1)
},
OnStart () {
this.picnm = 1
this.$vux.loading.show({
text: '正在上传...'
})
},
OnStart1 () {
this.picnm = 2
this.$vux.loading.show({
text: '正在上传...'
})
},
OnStart2 () {
this.picnm = 3
this.$vux.loading.show({
text: '正在上传...'
})
},
OnSuccess (response) {
console.log(response.data)
this.$vux.loading.hide()
if (response.data) {
this.$vux.toast.show({
text: '上传成功!'
})
this.files.push(response.data)
console.log(this.files, '00000')
} else {
this.$vux.toast.show({
text: response.msg,
type: 'warn'
})
}
},
OnSuccess2 (response, fil) {
console.log(response, fil, '图片上传')
this.$vux.loading.hide()
if (response.data) {
this.$vux.toast.show({
text: '上传成功!'
})

if (this.picnm === 1) {
this.files1 = response.data
this.bpbg1 = response.data.url || response.data.serverUrl
} else if (this.picnm === 2) {
this.files2 = response.data
this.bpbg2 = response.data.url || response.data.serverUrl
} else if (this.picnm === 3) {
this.files3 = response.data
this.bpbg3 = response.data.url || response.data.serverUrl
}
} else {
this.$vux.toast.show({
text: response.msg,
type: 'warn'
})
}
},
onError (errors) {
this.$vux.loading.hide()
this.$vux.toast.show({
text: errors,
type: 'warn'
})
},
commit () {
console.log(this.files1, this.files2, this.files3, this.files.length)

console.log(this.id, '0000')
if (this.files1 || this.files2 || this.files3 || this.files.length > 0) {
} else {
this.$vux.toast.show({
text: '请按规定上传违法证据!',
type: 'warn'
})
return
}
let opts = {
id: this.id,
videoList: [],
picList: []
}
let arr = []

if (this.files1) {
arr.push(this.files1.id)
}
if (this.files2) {
arr.push(this.files2.id)
}
if (this.files3) {
arr.push(this.files3.id)
}
if (this.files[0]) {
opts.videoList.push(this.files[0].id || '')
}
opts.picList = arr
this.$vux.loading.show()
supplementPost({ data: opts })
.then((response) => {
this.$vux.loading.hide()
const result = response.data
if (result.data) {
this.$vux.toast.show({
text: result.data
})
sessionStorage.setItem('currentType', 1)
setTimeout(() => {
this.$router.replace({ name: 'vioReportIndex', path: '/vioReportIndex' })
}, 1500)
} else {
this.$vux.toast.show({
text: result.data,
type: 'warn'
})
}
})
.catch((error) => {
this.$vux.loading.hide()
this.$vux.toast.show({
text: error,
type: 'warn'
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/views/vioReport/reportSupplement.vue